import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import useScrollReveal from "../hooks/useScrollReveal";
import ProductInquiryPanel from "../components/ProductInquiryPanel/ProductInquiryPanel";
import GetQuoteButton from "../components/GetQuoteButton/GetQuoteButton";
import "./ClientLayout.css";

const ClientLayout = () => {
  useScrollReveal();

  return (
    <>
      <Navbar />

      <main className="client-content">
        <Outlet />
      </main>

      <Footer />

      {/* Only rendered here (ClientLayout), so these never show on
          admin pages — AdminLayout doesn't import them. */}
      <ProductInquiryPanel />
      <GetQuoteButton />
    </>
  );
};

export default ClientLayout;